const FETCH_NOTIFICATIONS = 'notifications/FETCH_NOTIFICATIONS';
const FETCH_NOTIFICATIONS_START = 'notifications/FETCH_NOTIFICATIONS_START';
const FETCH_NOTIFICATIONS_SUCCESS = 'notifications/FETCH_NOTIFICATIONS_SUCCESS';
const UPDATE_NOTIFICATION_READ_SUCCESS =
  'notifications/UPDATE_NOTIFICATION_READ_SUCCESS';
const FETCH_NOTIFICATIONS_ERROR = 'notifications/FETCH_NOTIFICATIONS_ERROR';
const UPDATE_NOTIFICATION_READ = 'notifications/UPDATE_NOTIFICATION_READ';
const TOGGLE_NEWS_MODAL = 'notifications/TOGGLE_NEWS_MODAL';
const TOGGLE_TOOLTIP = 'notifications/TOGGLE_TOOLTIP';
const ADD_NOTIFICATION_MODAL = 'notifications/ADD_NOTIFICATION_MODAL';
const CHANGE_NEWS_MODAL_STATUS = 'notifications/CHANGE_NEWS_MODAL_STATUS';
const UPDATE_NOTIFICATION_NOT_READ =
  'notifications/UPDATE_NOTIFICATION_NOT_READ';

export default {
  FETCH_NOTIFICATIONS,
  FETCH_NOTIFICATIONS_START,
  FETCH_NOTIFICATIONS_SUCCESS,
  UPDATE_NOTIFICATION_READ_SUCCESS,
  FETCH_NOTIFICATIONS_ERROR,
  UPDATE_NOTIFICATION_READ,
  TOGGLE_NEWS_MODAL,
  TOGGLE_TOOLTIP,
  ADD_NOTIFICATION_MODAL,
  CHANGE_NEWS_MODAL_STATUS,
  UPDATE_NOTIFICATION_NOT_READ,
};
